import { useModel } from '@umijs/max';
import { useCallback, useEffect, useRef, useState } from 'react';
import { fetchTodoApprovals } from '@/services/oa-approval';

const POLL_INTERVAL_MS = 60 * 1000; // 60s

export default function useOaApproval(): {
  todoCount: number;
  refresh: () => Promise<void>;
} {
  const { initialState } = useModel('@@initialState') as any;
  const isAuthed: boolean = !!initialState?.currentUser;

  const [todoCount, setTodoCount] = useState<number>(0);
  const timerRef = useRef<ReturnType<typeof setInterval>>();

  const refresh = useCallback(async () => {
    if (!isAuthed) return;
    try {
      const res = await fetchTodoApprovals({ pageSize: 1 });
      if (res.code === 200) {
        setTodoCount(res.data?.total ?? 0);
      }
    } catch {
      // 静默失败，不阻断 UI
    }
  }, [isAuthed]);

  useEffect(() => {
    if (!isAuthed) {
      if (timerRef.current) clearInterval(timerRef.current);
      timerRef.current = undefined;
      setTodoCount(0);
      return;
    }
    refresh();
    timerRef.current = setInterval(refresh, POLL_INTERVAL_MS);
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [isAuthed, refresh]);

  return { todoCount, refresh };
}
